import { render } from "./AccountVue.vue?vue&type=template&id=1424267c"
import script from "./AccountVue.vue?vue&type=script&lang=js"
export * from "./AccountVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__